import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { compose, applyMiddleware, createStore } from 'redux';
// Import routing components
import {persistStore, autoRehydrate} from 'redux-persist';
import createActionBuffer from 'redux-action-buffer';
import {REHYDRATE} from 'redux-persist/constants';
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Link
} from 'react-router-dom'
import Home from './App';
import Login from './components/Authentication/login';
import Register from './components/Authentication/register';
import Feed from './components/Mealtrist/feed';
import Profile from './components/Mealtrist/profile';
import Saved from './components/Mealtrist/saved';
import Connections from './components/Mealtrist/connections';
import Plan from './components/Mealtrist/plan';
import Meal from './components/Mealtrist/meal';
import ShowMeal from './components/Mealtrist/showMeal';
import MealEdit from './components/Mealtrist/mealEdit';
import ProfileEdit from './components/Mealtrist/profileEdit';
import './index.css';

// import 'babel-polyfill';


import thunk from 'redux-thunk';
import promise from 'redux-promise';
import { createLogger } from 'redux-logger';
import allReducers from './reducers';


const logger = createLogger();
console.log(allReducers);

// add `autoRehydrate` as an enhancer to your store (note: `autoRehydrate` is not a middleware)

const enhancer = compose(
    autoRehydrate(),
    applyMiddleware(
        thunk, promise, logger, createActionBuffer(REHYDRATE)
    )
);

const store = createStore(
    allReducers,
    undefined,
    enhancer
);

// persistStore(store, {blacklist: ['orderConfirmation']}, () => {
//     console.log('rehydration complete')
// })
persistStore(store);
var test = "testing";


// You can use subscribe() to update the UI in response to state changes.
// Normally you'd use a view binding library (e.g. React Redux) rather than subscribe() directly.
// However it can also be handy to persist the current state in the localStorage.

const Root = ({ store }) => (
    <Provider store={store}>
        <Router>
            <div>
                <Route exact path="/" component={Home}/>
                <Route path={"/login"} component={Login}/>
                <Route path="/register" component={Register}/>
                {/*<Route path="/contact" component={ContactMe}/>*/}
                <Route path="/feed" component={Feed}/>
                <Route path="/profile/:id" render={props => <Profile {...props} />} />
                <Route path="/profile-edit/:id" render={props => <ProfileEdit {...props} />} />
                <Route path="/saved" component={Saved}/>
                <Route path="/plan" component={Plan}/>
                <Route path="/connections" component={Connections}/>
                <Route path="/add-meal" component={Meal}/>
                <Route path="/meal-show/:id" render={props => <ShowMeal {...props} />} />
                <Route path="/meal-edit/:id" render={props => <MealEdit {...props} />} />
            </div>
        </Router>
    </Provider>
);

Root.propTypes = {
    store: PropTypes.object.isRequired
};

ReactDOM.render(
    <Root store={store} />,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js